import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageKey } from '@ddt-web/generic-utils';
import { DebugQueryParamKey } from '@ddt-web/url';
import { Observable } from 'rxjs';

@Injectable()
export class ModelsInterceptorService implements HttpInterceptor {

	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// mock wealth web specific apis
		const modelsBrowseMockApi = this.isModelsBrowseMockEnabled(request);

		if (modelsBrowseMockApi) {
			// add function here to retrieve mock data
		}
		return next.handle(request);
	}

	// checks if models browse mock API flag is enabled
	// return true, if models browse request and flag is set true by either query param or localStorage
	private isModelsBrowseMockEnabled(request: HttpRequest<any>): boolean {
		const isModelsBrowseRequest = request.url.includes('model-families') || request.url.includes('model-family');

		if (isModelsBrowseRequest) {
			const parsedUrl = new URL(window.location.href);
			const mockMbQueryParam = Boolean(parsedUrl.searchParams.get(DebugQueryParamKey.MODELS_BROWSE_MOCK_API));
			const mockMbLocalStorage = Boolean(localStorage.getItem(LocalStorageKey.ModelsBrowseMockApi));
			return mockMbQueryParam || mockMbLocalStorage;
		}
		return false;
	}
}
